import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CompanyState } from './company.state';

export const selectCompanyState = createFeatureSelector<CompanyState>('company');

export const selectCompanies = createSelector(selectCompanyState, state => state.companies);
export const selectLoadedCompanyDetails = createSelector(selectCompanyState, state => state.loadedCompanyDetails);

export const selectLoading = createSelector(selectCompanyState, state => state.loading);
export const selectErrorMessage = createSelector(selectCompanyState, state => state.errorMessage);

export const selectEmployeesProcesses = createSelector(selectCompanyState, state => state.employeesProcesses);
export const selectEmployeesProcessesPagination = createSelector(
  selectCompanyState,
  state => state.employeesProcessesPagination
);

export const selectManagers = createSelector(selectCompanyState, state => state.managers);
export const selectManagersPagination = createSelector(selectCompanyState, state => state.managersPagination);
export const selectManagersListLoading = createSelector(selectCompanyState, state => state.loadingManagersList);
export const selectManagersErrorMessage = createSelector(selectCompanyState, state => state.managersErrorMessage);

export const selectLoadedManagerDetails = createSelector(selectCompanyState, state => state.loadedManagerDetails);
export const selectLoadingManagerDetails = createSelector(selectCompanyState, state => state.loadingManagerDetails);

export const selectLoadingCompanyOfSelfRegistered = createSelector(
  selectCompanyState,
  state => state.loadingCompanyOfSelfRegistered
);
export const selectCompanyOfSelfRegistered = createSelector(selectCompanyState, state => state.companyOfSelfRegistered);
export const selectAllActiveCompanies = createSelector(selectCompanyState, state => state.allActiveCompanies);
export const selectAllInactiveCompanies = createSelector(selectCompanyState, state => state.allInactiveCompanies);
